import React from "react";

function getHighlightedText(text, highlight) {
  if (highlight) {
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <mark key={i} className="font-bold">
              {part}
            </mark>
          ) : (
            part
          )
        )}
      </>
    );
  }
  return text;
}

export const HighlightChars = ({ str, search }) =>
  getHighlightedText(str, search);
